export const MANAGE_GUEST = 'manage_guest';
export const MANAGE_TEAM = 'manage_team';
export const CLIENT_SEARCH = 'client_search';
export const RELATION_SEARCH = 'relation_search';
export const DONOR_SEARCH = 'donor_search';
